import { Inject } from "typescript-ioc";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { Div } from "Ui/Scripts/Div";
import { Utils } from "Helpers/Scripts/Utils";

export class LoadArticlesView extends UiComponent {
    private readonly LOAD_MORE: string = ".js-load-more";
    private readonly ARTICLES: string = ".js-articles";
    private readonly ROWS_TO_SHOW: string = "rowsToShow";
    private readonly ROWS_TO_LOAD: string = "rowsToLoad";

    public readonly DESKTOP_ARTICLES_IN_ROW: number = 3;
    public readonly MOBILE_ARTICLES_IN_ROW: number = 1;
    public readonly MAX_MOBILE_BREAKPOINT_INDEX: number = 1;
    public readonly ARTICLE_ITEM: string = ".js-article";
    public loadMore: Div;
    public articles: Div;
    public articleItem: string;
    public rowsToShow: number;
    public rowsToLoad: number;
    public articlesInRow: number;

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    public init(): void {
        const dataHolder = this.findElement(this.ARTICLES);
        if (!dataHolder) {
            throw new Error("Data holder not found!");
        }

        this.articles = this.createComponent(Div, this.ARTICLES);
        this.loadMore = this.createComponent(Div, this.LOAD_MORE);
        this.rowsToShow = Utils.getData(dataHolder, this.ROWS_TO_SHOW);
        this.rowsToLoad = Utils.getData(dataHolder, this.ROWS_TO_LOAD);
    }
}
